<div
  class="flex flex-row items-center gap-2 rounded-md bg-slate-100 px-4 py-2 text-slate-700"
>
  <mat-icon class="shrink-0">insert_chart</mat-icon>
  <div class="flex grow flex-col">
    <div class="flex flex-row items-center gap-1">
      @if (reportLink(); as reportLink) {
        <a
          matTooltip="Open Custom Report"
          class="flex items-center gap-1"
          [routerLink]="reportLink"
        >
          <span>{{ customReport().name }}</span>
        </a>
      } @else {
        <span>{{ customReport().name }}</span>
      }
    </div>
    <div class="text-xs opacity-50">
      <ng-content />
    </div>
    @if (reportRunRef()) {
      @if (reportRunExists()) {
        <a
          class="text-primary-500 flex cursor-pointer flex-row items-center gap-1 text-xs hover:underline"
          matTooltip="View the historical report results for this campaign run"
          (click)="viewRunResults()"
        >
          <mat-icon class="icon-xs">history</mat-icon>
          View Results
        </a>
      } @else {
        <span
          class="flex items-center gap-1 text-xs text-slate-400"
        >
          <mat-icon class="icon-xs">history</mat-icon>
          View Results (Expired)
        </span>
      }
    }
  </div>

  <div>
    <mat-icon
      #filterTooltipOrigin="cdkOverlayOrigin"
      cdkOverlayOrigin
      class="icon-sm opacity-50"
      >info</mat-icon
    >

    <pt-custom-tooltip [target]="filterTooltipOrigin">
      <div class="flex flex-col p-2">
        @if (dataSource(); as dataSourceValue) {
          <pr-data-source-display [dataSource]="dataSourceValue" />
        }
        <pr-pre-selected-filters
          [customReport]="customReport()"
          [columnLayout]="true"
        />
      </div>
    </pt-custom-tooltip>
  </div>
</div>
